import { FC, useEffect, useState } from 'react';
import NudosButton from 'components/NudosComponents/NudosButton/NudosButton';
import { IToolEvidence } from '../../toolEvidenceCarousel.types';
import './ToolEvidenceModal.scss';

/**
 * Modal para mostrar una imagen de evidencia en tamaño completo con navegación y opciones de descarga.
 * Incluye botones para cerrar, descargar la imagen y flechas de navegación entre múltiples imágenes.
 * @param evidence - Evidencia actual a mostrar
 * @param allEvidences - Array de todas las evidencias para navegación
 * @param isOpen - Si el modal está abierto
 * @param onClose - Función para cerrar el modal
 */
const ToolEvidenceModal: FC<ToolEvidenceModalProps> = ({ evidence, allEvidences, isOpen, onClose }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const currentEvidence = allEvidences?.[currentIndex];

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e?.target === e?.currentTarget) {
      onClose();
    }
  };

  const handleDownloadImage = () => {
    const currentEvidence = allEvidences?.[currentIndex];
    if (currentEvidence?.imageUrl) {
      window.open(currentEvidence.imageUrl, '_blank');
    }
  };

  useEffect(() => {
    if (evidence && allEvidences) {
      const index = allEvidences?.findIndex(e => e?.id === evidence?.id);
      setCurrentIndex(index !== -1 ? index : 0);
    }
  }, [evidence, allEvidences]);

  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };

    if (isOpen) {
      window.addEventListener('keydown', handleEsc);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      window.removeEventListener('keydown', handleEsc);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);

  if (!isOpen || !evidence) return null;

  return (
    <div className="toolEvidenceModal" onClick={handleBackdropClick}>
      <div className="modalContent">
        <img src={currentEvidence?.imageUrl} alt={`Evidencia ${currentEvidence?.id || ''}`} className="modalImage" />

        <div className="modalActionButtons">
          <NudosButton
            buttonText="Cerrar"
            handleClick={onClose}
            customWidth="180px"
            customHeight="40px"
            colorPalette="secondary"
          />
          <NudosButton
            buttonText="Descargar imagen"
            handleClick={handleDownloadImage}
            customWidth="180px"
            customHeight="40px"
            customClassName="darkButton"
          />
        </div>
      </div>
    </div>
  );
};

interface ToolEvidenceModalProps {
  evidence: IToolEvidence | null;
  allEvidences: IToolEvidence[];
  isOpen: boolean;
  onClose: () => void;
}

export default ToolEvidenceModal;

